class ConnectedWeb3Provider {
  static web3 = null;
}

export default ConnectedWeb3Provider;
